import { escape } from 'lodash';

import { submitWorkshopFF } from '../../../utils/services';

export const UPDATE_FIELD_VALUE_FF_WS = 'UPDATE_FIELD_VALUE_FF_WS';
export const UPDATE_FORM_STATUS_FF_WS = 'UPDATE_FORM_STATUS_FF_WS';
export const SUBMIT_IN_PROGRESS_FF_WS = 'SUBMIT_IN_PROGRESS_FF_WS';
export const SUBMIT_SUCCESS_FF_WS = 'SUBMIT_SUCCESS_FF_WS';
export const SUBMIT_ERROR_FF_WS = 'SUBMIT_ERROR_FF_WS';
export const RESET_FORM_FF_WS = 'RESET_FORM_FF_WS';

const submitInProgress = () => ({
    type: SUBMIT_IN_PROGRESS_FF_WS,
    payload: {}
});

const submitSuccess = () => ({
    type: SUBMIT_SUCCESS_FF_WS,
    payload: {}
});

const submitError = error => ({
    type: SUBMIT_ERROR_FF_WS,
    payload: error
});

export const updateValue = event => dispatch => {
    const { name, value } = event.target;

    dispatch({
        type: UPDATE_FIELD_VALUE_FF_WS,
        payload: { name, value }
    });
};

export const submitFFForm = workshopName => async (dispatch, getState) => {
    dispatch(submitInProgress());
    try {
        const { fields } = getState().feedbackFormWs;
        const data = { workshopName: escape(workshopName) };
        Object.keys(fields).forEach(key => {
            data[key] = escape(fields[key].value);
        });
        await submitWorkshopFF(data);
        dispatch(submitSuccess());
    } catch (error) {
        const resp = error.response ? error.response.data : { msg: '' };
        dispatch(submitError(resp));
    }
};

export const updateFormStatus = (fieldName, value) => ({
    type: UPDATE_FORM_STATUS_FF_WS,
    payload: {
        fieldName,
        value
    }
});

export const resetFormAction = () => ({ type: RESET_FORM_FF_WS });
